import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import GroupsListItem from "./GroupListItem";
import GroupsEditForm from "./GroupEditForm";
import { useGetCompanyModule, useGetModules } from "../../hooks/groups/Modules";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import LoadingSpinner from "../global/LoadingSpinner";

function GroupsList() {
    const { t, i18n } = useTranslation();
    const { data, isLoading, isError, refetch } = useGetModules();
    const { data:company, isLoading:CompanyisLoading, isError:CompanyisError } = useGetCompanyModule();
    const [isNew, setIsNew] = useState(false);
    const [newID, setNewID] = useState(null);
    const [openId, setOpenId] = useState(null);

    if (isLoading || CompanyisLoading) return <LoadingSpinner/>
    if (isError) return 'An error has occurred: ' + isError.message;

    const handleClose = (id) => {
        setOpenId(id);
    }

    //if (data) return <pre>{JSON.stringify(data, null,2)}</pre>;

    return (
        <>
       {/*open={openId===company.id} */}
       {/*open={openId===group.id}*/}
        <DndProvider  backend={HTML5Backend}>
        <div className="modulWrap"><GroupsListItem id={company.id} text={company.descriptive_name} companyId={company.id} close={handleClose} />  </div>
            {data.map((group, key) => {
                if(newID !== group.id)
                    return <GroupsListItem key={key} id={group.id} text={group.descriptive_name} close={handleClose}  /> 
                else return null;
            })}

            <div className="modulWrap">
                <div className="groupOverview-list groupOverview-listNew" onClick={() => setIsNew(true)}>
                    <strong>{t("admin.group.cn")}</strong>
                    <em>{t("admin.group.ct")}</em>
                    <button className="btn btn-default btn-add"
                        title={t("admin.group.nm")} />
                </div>
            </div>

            {isNew && (<div className="modulWrap"><GroupsEditForm id={newID} onNew = {(id) => setNewID(id)} onClose={() => {setIsNew(false); setNewID(null); refetch() } } /></div>)}
            </DndProvider>
        </>
    );
}

export default GroupsList;